var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Breadcrumb',{attrs:{"separator":">"}},_vm._l((_vm.data),function(item){return _c('Breadcrumb-item',{key:item.name,attrs:{"to":item.href}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }